export default function getParam(name: string, urlParams: URLSearchParams): string | null {
  const key = [...urlParams.keys()].find(k => k.toLowerCase() === name)
  return key ? urlParams.get(key) : null
}
